module.exports = __webpack_public_path__ + "static/media/Research.223361a7.jpg";